// store/slices/complexOrderListSlice.ts (админка)

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ComplexOrderInterface } from '../../common/types/interfaces'

const initialState: { data: ComplexOrderInterface[] } = {
  data: [],
}

export const complexOrderListSlice = createSlice({
  name: 'complex-order-list',
  initialState,
  reducers: {
    setComplexOrderList: (state, action: PayloadAction<ComplexOrderInterface[]>) => {
      state.data = [...action.payload]
    },
  },
})

export const { setComplexOrderList } = complexOrderListSlice.actions

export const selectComplexOrderList = (state: RootState) => state.complexOrderList.data
export const selectComplexOrderItem = (state: RootState, id: number) =>
  state.complexOrderList.data.find((el) => el.id === id)

export default complexOrderListSlice.reducer
